import Footer from './footer/footer'
import Header from './header/header'
import Layout from './layout/layout'

class Page {
  constructor() {
    this.init()
  }

  init() {
    new Layout()
    new Header()
    new Footer()
  }
}

export default Page
